export function importProjectFont(project: 'ok' | 'vk') {
  return import(`./${project}/index.css`);
}
